let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lTWNK")).then(() => parcelRequire('1ybgY'));